export enum Languages {
  Spanish = 'ES',
  Portuguese = 'PT'
}
